import { render, staticRenderFns } from "./DropdownAlt.vue?vue&type=template&id=a210bb7e&scoped=true&"
import script from "./DropdownAlt.vue?vue&type=script&lang=ts&"
export * from "./DropdownAlt.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownAlt.vue?vue&type=style&index=0&id=a210bb7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a210bb7e",
  null
  
)

export default component.exports